import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields';
// interface FieldListProps {
//   company_id?: number;
//   name?: string;
//   address?: string;
//   use_buildee_flg?: number;
//   use_roan_flg?:number;
//   use_gk_flg ?:number;
//   order?:string;
// }
// api :GET, '/api/private/fields/list', '現場情報取得API（CSVダウンロードAPIは末尾に.csvを付与）'
const list = param => {
  // console.log('Fields.js list', param);
  return requestWithToken({
    method: 'GET',
    url: path.concat('/list'),
    params: param,
  });
};

const workColumnsSettings = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${fieldId}/work_columns_settings`,
    params,
  });
};

// api :GET, '/api/private/fields/:id', '現場情報の取得(単一レコード)'
const info = (fieldId, param, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}`),
    params: param,
    isQuiet,
  });
};

// api :PATCH, '/api/private/fields/:id/oxygen_lack_field_image_category_codes', '酸欠帳票に使用するキープラン更新API'
const oxygenLackFieldImageCategoryCodesUpdate = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/oxygen_lack_field_image_category_codes`,
    data: param,
  });
};

// api :PATCH, '/api/private/fields/:id/oxygen_lack', '「酸欠帳票印刷フラグ」の更新'
const oxygenLackUpdate = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/oxygen_lack`,
    data: param,
  });
};

// api :PATCH, '/api/private/fields/:id/total_workers_nums', '「各種設定 - 作業員集計の帳票項目」の更新'
const totalWorkersNumsUpdate = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/total_workers_nums`,
    data: param,
  });
};

// TODO: mainContractorFlagのデフォルト引数はtrue/falseどちらが例外的に使われるのか概ね定まってきたら指定する
const currentPrimeContractorsCompanyBranchId = (
  fieldId,
  mainContractorFlag
) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/current_prime_contractors_company_branch_id`),
    params: { main_contractor_flag: mainContractorFlag },
  });
};

const fieldItem = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_item`),
  });
};

const primeContractorInfo = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/prime_contractor_info`),
  });
};

const allPartnerCompanyList = (fieldId, params, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${fieldId}/works/list_for_all_partner_company`,
    params,
    isQuiet,
  });
};

const listForOutputCsv = params => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/list_for_output_csv`),
    params,
    isQuiet: params.isQuiet || false,
  });
};

// eslint-disable-next-line no-unused-vars
const systemUseHistoryList = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${fieldId}/contract_histories`,
  });
};

const listLwTalkRoom = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${fieldId}/lw_talkrooms/list`,
  });
};

const listDirectRooms = params => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/direct_talkrooms/list`,
    params,
  });
};

// 元請BOXから現場監督を削除する場合、404になってpermission_errorにならないようにuseDefaultCatch=falseを付ける
const checkAccessible = fieldId => {
  return requestWithToken(
    {
      method: 'GET',
      url: `${path}/${fieldId}/check_accessible`,
    },
    false
  );
};

export const FieldService = {
  list,
  workColumnsSettings,
  info,
  oxygenLackFieldImageCategoryCodesUpdate,
  oxygenLackUpdate,
  totalWorkersNumsUpdate,
  fieldItem,
  primeContractorInfo,
  currentPrimeContractorsCompanyBranchId,
  allPartnerCompanyList,
  listForOutputCsv,
  systemUseHistoryList,
  listLwTalkRoom,
  checkAccessible,
  listDirectRooms,
};
export default FieldService;



// WEBPACK FOOTER //
// ./src/services/Fields.js